<template>
  <div class="chat-popup" :class="{ open }" v-if="user.chat">
    <div v-show="open">
      <ChatWidget
        ref="rooms"
        :user="user"
        :visible="open"
        mode="popup"
        @toggleDialog="toggle"
        @unreadBadge="unreadBadge"
        @markedBadge="markedBadge"
      />
    </div>
    <div class="icon-badge" v-if="!open">
      <a @click="toggle(true)" class="chat-icon">
        <i class="fas fa-comment" />
      </a>
      <el-badge
        class="unread"
        :value="unread"
        v-if="unread > 0"
        title="Unread"
      />
      <el-badge
        class="marked"
        :value="marked"
        v-if="marked > 0"
        type="success"
        title="Marked"
      />
    </div>
  </div>
</template>
<script>
import ChatWidget from "@/default/pages/chats/widget.vue";
export default {
  name: "ChatPopup",
  components: {
    ChatWidget,
  },
  data() {
    return {
      user: {},
      open: false,
      unread: 0,
      marked: 0,
    };
  },
  mounted() {
    this.loadOptions();
    window.ChatPopup = { toggle: this.toggle, selectRoom: this.selectRoom };
  },
  methods: {
    async loadOptions() {
      try {
        this.user = (await this.$http.get("/api/v1/users/profile.json")).data;
      } catch (ex) {
        console.error(ex);
      }
    },
    toggle(status) {
      this.open = status;
      if (this.open) {
        setTimeout(() => {
          this.$refs.rooms.computeMinArea();
        }, 250);
      } else {
        this.$refs.rooms.unselectRoom();
      }
    },
    selectRoom(uuid) {
      this.toggle(true);
      this.$refs.rooms.selectRoom(uuid);
    },
    unreadBadge(num) {
      this.unread = num;
    },
    markedBadge(num) {
      this.marked = num;
    },
  },
};
</script>
<style lang="scss">
.chat-popup {
  @apply fixed bottom-1 right-1 z-[5000];

  &.open {
    background: #fff;
    box-shadow: 0px 0px 8px 0px rgba(51, 51, 51, 1);
    -webkit-box-shadow: 0px 0px 8px 0px rgba(51, 51, 51, 1);
    -moz-box-shadow: 0px 0px 8px 0px rgba(51, 51, 51, 1);
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    border: 1px solid #ddd;
  }

  .chat-widget {
    width: 650px;
    height: 60vh;

    .main {
      height: calc(60vh - 35px);
    }
  }

  .icon-badge {
    position: relative;

    .chat-icon {
      padding: 8px;
      border: 1px solid #039cd8;
      border-radius: 20px;
      width: 40px;
      height: 40px;
      display: block;
      background: #00acf0;

      .fa-comment {
        color: #fff;
        font-size: 20px;
      }
    }

    .unread {
      position: absolute;
      top: -5px;
      right: -5px;
    }

    .marked {
      position: absolute;
      top: -5px;
      left: -5px;
    }
  }
}
</style>
